import { datadogLogs } from "@datadog/browser-logs";

/**
 * Filter function for Datadog logs
 * Determines which log entries should be sent to Datadog
 * @param {Object} log - The log entry object from Datadog
 * @returns {boolean} - true to send the log, false to filter it out
 */
function shouldSendLog(log) {
  // Catch AbortErrors but only ignore specific ones for now
  if (log.error && log.error.name === "AbortError") {
    // Ignore AbortError without reason (thrown when .abort() is called with no reason)
    // Most often caused by turbo when a user navigates between pages too quickly.
    if (log.error.message === "signal is aborted without reason") {
      return false;
    }
    // Let all other AbortErrors through for now - they might indicate real issues
  }

  return true;
}

/**
 * Initialize Datadog browser log collection
 * Reads configuration from meta tags and sets up logging with filtering
 */
export function initializeDatadog() {
  // Get Datadog configuration from meta tags
  const datadogClientToken = document.querySelector('meta[name="datadog_client_token"]')?.getAttribute("content");
  const datadogSite = document.querySelector('meta[name="datadog_site"]')?.getAttribute("content");
  const railsEnv = document.querySelector('meta[name="rails_env"]')?.getAttribute("content");
  const appVersion = document.querySelector('meta[name="app_version"]')?.getAttribute("content");

  // Only initialize Datadog if configuration is available
  if (datadogClientToken && datadogSite && railsEnv && appVersion) {
    datadogLogs.init({
      clientToken: datadogClientToken,
      site: datadogSite,
      forwardErrorsToLogs: true,
      // preserve v6 behavior: forwardErrorsToLogs no longer captures console.error in v7
      // (see PR #3318 / browser-sdk#4356)
      forwardConsoleLogs: ["error"],
      sessionSampleRate: 100,
      service: "trigo-app",
      env: railsEnv,
      version: appVersion,
      beforeSend: shouldSendLog,
    });

    console.log("Datadog browser log collection initialized successfully.");
  } else {
    console.warn("Datadog configuration not found. Browser logs will not be sent to Datadog.");
  }
}
